/* GENERATED by scripts/gen-data.mjs — film scene "f-delivery" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_DELIVERY: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "pb",
      "x": 14,
      "y": 126,
      "w": 120,
      "h": 56,
      "lKey": "films:f-delivery.items.pb.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "pb",
      "to": "lg"
    },
    {
      "k": "box",
      "id": "lg",
      "x": 158,
      "y": 126,
      "w": 124,
      "h": 56,
      "lKey": "films:f-delivery.items.lg.l",
      "sKey": "films:f-delivery.items.lg.s"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "lg",
      "to": "cs"
    },
    {
      "k": "box",
      "id": "cs",
      "x": 308,
      "y": 126,
      "w": 136,
      "h": 56,
      "lKey": "films:f-delivery.items.cs.l"
    },
    {
      "k": "box",
      "id": "cr",
      "x": 308,
      "y": 30,
      "w": 136,
      "h": 52,
      "lKey": "films:f-delivery.items.cr.l",
      "sKey": "films:f-delivery.items.cr.s"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "cs",
      "to": "cr",
      "dash": true
    },
    {
      "k": "chip",
      "id": "rd",
      "x": 158,
      "y": 30,
      "w": 124,
      "h": 52,
      "lKey": "films:f-delivery.items.rd.l",
      "sKey": "films:f-delivery.items.rd.s"
    },
    {
      "k": "wire",
      "id": "w4",
      "from": "rd",
      "to": "cs",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w5",
      "from": "cs",
      "to": "wr"
    },
    {
      "k": "box",
      "id": "wr",
      "x": 472,
      "y": 126,
      "w": 154,
      "h": 56,
      "lKey": "films:f-delivery.items.wr.l",
      "sKey": "films:f-delivery.items.wr.s"
    }
  ],
  "steps": [
    {
      "on": [
        "pb",
        "lg",
        "w1"
      ],
      "hot": [
        "lg",
        "w1"
      ],
      "capKey": "films:f-delivery.steps.0.cap"
    },
    {
      "on": [
        "pb",
        "lg",
        "cs",
        "w1",
        "w2"
      ],
      "hot": [
        "cs",
        "w2"
      ],
      "capKey": "films:f-delivery.steps.1.cap"
    },
    {
      "on": [
        "lg",
        "cs",
        "w2",
        "cr",
        "w3"
      ],
      "hot": [
        "cr",
        "w3"
      ],
      "capKey": "films:f-delivery.steps.2.cap"
    },
    {
      "on": [
        "lg",
        "cs",
        "w2",
        "cr",
        "w3",
        "rd",
        "w4"
      ],
      "hot": [
        "rd",
        "w4"
      ],
      "capKey": "films:f-delivery.steps.3.cap"
    },
    {
      "on": [
        "lg",
        "cs",
        "w2",
        "cr",
        "w3",
        "rd",
        "w4",
        "wr",
        "w5"
      ],
      "hot": [
        "wr",
        "w5"
      ],
      "capKey": "films:f-delivery.steps.4.cap"
    }
  ]
};
